require('./brokerContributionInvestmentFund.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
// @ components
const { BrokerContributionInvestmentFundStep1 } = require('../brokerContributionInvestmentFundStep1/brokerContributionInvestmentFundStep1');
const { BrokerContributionInvestmentFundStep2 } = require('../brokerContributionInvestmentFundStep2/brokerContributionInvestmentFundStep2');
const BrokerContributionInvestmentFundSuccess = require('../brokerContributionInvestmentFundSuccess/brokerContributionInvestmentFundSuccess');
// @ helpers
const { taggingEventHandled } = require('../../../../utilities/taggingEventHandled');
const { PROC_BROKER_INVESTMENT_CONTRIBUTIONS } = require('utilities/tagging.js');

class BrokerContributionInvestmentFund extends React.Component {
    constructor(props) {
        super(props);
        this.onCancel = this.onCancel.bind(this);
        this.onFinish = this.onFinish.bind(this);
    }

    onCancel() {
        this.props.onCancel();
    }

    onFinish() {
        this.props.onFinish();
    }

    buildContent() {
        const { immContributionFunds, immAccounts } = this.props;
        if (immContributionFunds && !immContributionFunds.get('submitSuccessful')) {
            return this.buildWizard();
        } else {
            return (
                <BrokerContributionInvestmentFundSuccess
                    immSubscription={immContributionFunds}
                    immContributionFunds={immContributionFunds}
                    immAccounts={immAccounts}
                />
            );
        }
    }

    buildWizard() {
        const {
            immContributionFunds,
            isin,
            onStepChange,
            customMinimumPurchaseAmount,
            amount,
            amountErrorState,
            isValidDate,
            amountErrorMsg,
            setAmount,
            periodicityError,
            periodicityErrorMsg,
            periodicityValue,
            periodicityOptions,
            setPeriodicity,
            setValidityDate,
            selectedDate,
            setDatePickerError,
            datePickerDisabled,
            minDate,
            validateStep,
            setVisibleStep,
            setWillCancel,
            wizzardTitle,
            immFlagBasedFeatures,
        } = this.props;
        const immSteps = immContributionFunds.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immContributionFunds.get('visibleStep');
        const minimunAmount = customMinimumPurchaseAmount.get('additionalSubscriptionAmount');
        const allowContinue = (amount >= parseFloat(minimunAmount)) && !amountErrorState && isValidDate;
        const isFetching = immContributionFunds.get('isFetching');
        const wizardClass = 'contribution-investment__wizard';
        const immFinalButton = 'broker-hireInvestmentSubmit';
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.onFinish,
            cancel: this.onCancel
        };
        const headerMenuData = {
            title: wizzardTitle,
            linksData: []
        };
        const tealiumEventActionByStep = {
            1: 'investmentDetails',
            2: 'termsConditions'
        }

        const tealiumEvents = {
            next: {
                data: true,
                categoriaEvento: 'buyFundsPeriodicContribution',
                accionEvento: tealiumEventActionByStep[visibleStep],
                etiquetaEvento: 'comprar',
                productName: immSteps.getIn([0, 'contributionFunds', 'name']),
                productID: isin,
                periodicity: periodicityValue,
                amount: amount
            },
            previous: {
                data: true,
                categoriaEvento: 'buyFundsPeriodicContribution',
                accionEvento: tealiumEventActionByStep[visibleStep],
                etiquetaEvento: 'anterior',
                productName: immSteps.getIn([0, 'contributionFunds', 'name']),
                productID: isin
            },
            cancel: {
                data: true,
                categoriaEvento: 'buyFundsPeriodicContribution',
                accionEvento: tealiumEventActionByStep[visibleStep],
                etiquetaEvento: 'cancelar',
                productName: immSteps.getIn([0, 'contributionFunds', 'name']),
                productID: isin
            },
            finish: {
                data: true,
                categoriaEvento: 'buyFundsPeriodicContribution',
                accionEvento: tealiumEventActionByStep[visibleStep],
                etiquetaEvento: 'comprar',
                productName: immSteps.getIn([0, 'contributionFunds', 'name']),
                productID: isin
            }
        }



        return (
            <Wizard
                wizardClass={wizardClass}
                actions={actions}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                immSteps={immSteps}
                hasHeaderMenu={true}
                headerMenuData={headerMenuData}
                tealiumEvents={tealiumEvents}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    nextButton={true}
                    isLoading={isFetching}
                    nextButtonDisabled={!allowContinue}
                >
                    <BrokerContributionInvestmentFundStep1
                        immContributionFunds={immContributionFunds}
                        isin={isin}
                        onStepChange={onStepChange}
                        customMinimumPurchaseAmount={customMinimumPurchaseAmount}
                        amount={amount}
                        amountErrorState={amountErrorState}
                        amountErrorMsg={amountErrorMsg}
                        setAmount={setAmount}
                        periodicityError={periodicityError}
                        periodicityErrorMsg={periodicityErrorMsg}
                        periodicityValue={periodicityValue}
                        periodicityOptions={periodicityOptions}
                        setPeriodicity={setPeriodicity}
                        setValidityDate={setValidityDate}
                        selectedDate={selectedDate}
                        minDate={minDate}
                        setDatePickerError={setDatePickerError}
                        datePickerDisabled={datePickerDisabled}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    previousButton={true}
                    finishButton={true}
                    addLoadingBehaviour={true}
                    immFinalButton={immFinalButton}
                >
                    <BrokerContributionInvestmentFundStep2
                        immContributionFunds={this.props.immContributionFunds}
                        immAccounts={this.props.immAccounts}
                        immFlagBasedFeatures={immFlagBasedFeatures}
                        onStepChange={this.props.onStepChange}
                        handleChangeReadChecked={this.props.handleChangeReadChecked}
                        resetFetchedPre={this.props.resetFetchedPre}
                        validateEconomicReport={this.props.validateEconomicReport}
                        removeLegalDocumentation={this.props.removeLegalDocumentation}
                        extantDataFetch={this.props.extantDataFetch}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    render() {
        return this.buildContent();
    }
}

BrokerContributionInvestmentFund.propTypes = {
    immContributionFunds: PropTypes.object,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    wizzardTitle: PropTypes.object,
    isin: PropTypes.string.isRequired,
    onStepChange: PropTypes.func,
    customMinimumPurchaseAmount: PropTypes.number,
    amount: PropTypes.number,
    amountErrorState: PropTypes.bool,
    errorMsg: PropTypes.string,
    periodicityError: PropTypes.bool,
    periodicityErrorMsg: PropTypes.string,
    periodicityValue: PropTypes.string,
    periodicityOptions: PropTypes.array,
    setPeriodicity: PropTypes.func.isRequired,
    setAmount: PropTypes.func,
    setValidityDate: PropTypes.func.isRequired,
    selectedDate: PropTypes.object,
    minDate: PropTypes.object,
    setDatePickerError: PropTypes.func,
    datePickerDisabled: PropTypes.bool,
    isValidDate: PropTypes.bool,
    history: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object,
    handleChangeReadChecked: PropTypes.func.isRequired,
    resetFetchedPre: PropTypes.func.isRequired,
    validateEconomicReport: PropTypes.func.isRequired,
    removeLegalDocumentation: PropTypes.func.isRequired,
    extantDataFetch: PropTypes.func,
};

module.exports = BrokerContributionInvestmentFund;
